import { ModalProps } from "antd";
import CommonButton from "../../CommonButton";
import { CommonModal } from "../../Modal/CommonModal";
import Loader from "../../Loader";
import { Size } from "../../../constants/enum";
import styles from "./styles.module.scss";
import classNames from "classnames";
interface IProps extends ModalProps {
  children?: React.ReactNode;
  titleHeader?: string | React.ReactElement;
  title: string | React.ReactElement;
  textOke: string | React.ReactElement;
  textCancel?: string | React.ReactElement;
  closeIcon?: boolean;
  isVisible?: boolean;
  header?: string;
  handleCancel?: () => void;
  handleOke?: () => void;
  handleClose?: () => void;
  isLoading?: boolean;
}
const ModalConfirm = (props: IProps) => {
  const {
    children,
    titleHeader,
    title,
    textOke,
    textCancel,
    closeIcon = true,
    isVisible = false,
    isLoading = false,
    header,
    handleCancel,
    handleOke,
    handleClose,
  } = props;

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <CommonModal
          titleHeader={titleHeader}
          className={styles.modalConfirm}
          closable={closeIcon}
          isModalVisible={isVisible}
          handleClose={handleClose}
          children={
            <>
              <div className={styles.header}>{header || "Confirm"}</div>
              <div className={styles.container}>
                <h2 className={styles.title}>{title}</h2>
                <h2 className={styles.title}>{children}</h2>
                <div
                  className={classNames(styles.buttonContainer, {
                    [styles.btnGroup]: !!handleCancel,
                  })}
                >
                  <CommonButton
                    onClick={handleOke}
                    size={Size.FullWidth}
                    text={textOke}
                  />
                  {handleCancel ? (
                    <CommonButton
                      onClick={handleCancel}
                      size={Size.FullWidth}
                      text={textCancel as string}
                    />
                  ) : null}
                </div>
              </div>
            </>
          }
        />
      )}
    </>
  );
};
export default ModalConfirm;
